'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Functions = require('../core/Functions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ActiveProvider = function (_React$Component) {
  _inherits(ActiveProvider, _React$Component);

  function ActiveProvider(props) {
    _classCallCheck(this, ActiveProvider);

    var _this = _possibleConstructorReturn(this, (ActiveProvider.__proto__ || Object.getPrototypeOf(ActiveProvider)).call(this, props));

    _this.state = {
      active: false
    };
    _this.handleMouseDown = _this.handleMouseDown.bind(_this);
    _this.handleKeyDown = _this.handleKeyDown.bind(_this);
    _this.handleKeyUp = _this.handleKeyUp.bind(_this);
    _this.handleBlur = _this.handleBlur.bind(_this);
    return _this;
  }

  _createClass(ActiveProvider, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('mouseup', this._handleWindowMouseUp);
    }
  }, {
    key: 'handleMouseDown',
    value: function handleMouseDown(evt) {
      var _this2 = this;

      (0, _Functions.callIfPossible)(this.props.onMouseDown, evt);
      this.setState({ active: true });
      this._handleWindowMouseUp = function () {
        _this2.setState({ active: false });
        window.removeEventListener('mouseup', _this2._handleWindowMouseUp);
      };
      window.addEventListener('mouseup', this._handleWindowMouseUp);
    }
  }, {
    key: 'handleKeyDown',
    value: function handleKeyDown(evt) {
      (0, _Functions.callIfPossible)(this.props.onKeyDown, evt);
      var key = evt.key;

      if (key !== 'Enter' && key !== ' ') return;
      this.setState({ active: true });
    }
  }, {
    key: 'handleKeyUp',
    value: function handleKeyUp(evt) {
      (0, _Functions.callIfPossible)(this.props.onKeyUp, evt);
      var key = evt.key;

      if (key !== 'Enter' && key !== ' ') return;
      this.setState({ active: false });
    }
  }, {
    key: 'handleBlur',
    value: function handleBlur(evt) {
      (0, _Functions.callIfPossible)(this.props.onKeyUp, evt);
      if (this.state.active) this.setState({ active: false });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          activeProp = _props.active;
      var active = this.state.active;

      return children({
        active: activeProp != null ? activeProp : active,
        onMouseDown: this.handleMouseDown,
        onKeyDown: this.handleKeyDown,
        onKeyUp: this.handleKeyUp,
        onBlur: this.handleBlur
      });
    }
  }]);

  return ActiveProvider;
}(_react2.default.Component);

ActiveProvider.displayName = 'ActiveProvider';

exports.default = ActiveProvider;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.2644/js/providers/ActiveProvider.js
// module id = 267
// module chunks = 3 4 5